import { Box, Button, Heading, Text } from "@chakra-ui/react";
import { ProjectDocument } from "~/core/types";
import DateCountdown from "./DateCountdown";
import { tsOrStringToDate } from "~/core/helpers";
import useRegistrationTimeContext, {
  RegistrationStatus,
} from "~/context/RegistrationTime.context";

function handleCalendar(
  dateString: string | undefined,
  title: string,
  desc: string
): void {
  if (!dateString) return;

  const dString = dateString
    .replace(/:/g, "")
    .replace(/-/g, "")
    .replace(/\./g, "");

  const currentUrl = encodeURIComponent(window.location.href);

  const calendarUrl =
    "https://www.google.com/calendar/render?action=TEMPLATE&text=" +
    title +
    "&details=" +
    encodeURIComponent(desc) +
    "&location=" +
    currentUrl +
    "&dates=" +
    dString +
    "%2F" +
    dString;
  window.open(calendarUrl, "_blank");
}

export default function RegistrationCountdown({
  projectData,
}: {
  projectData?: ProjectDocument;
}) {
  const { status, dateString } = useRegistrationTimeContext();

  if (status === RegistrationStatus.closed) {
    return (
      <Box w={"100%"} px={8}>
        <Text color={"red.400"}>
          Registration is closed on{" "}
          {tsOrStringToDate(dateString as string)?.toUTCString()}. Thank you for
          your interest.
        </Text>
      </Box>
    );
  }

  if (status === RegistrationStatus.willOpen) {
    return (
      <Box w={"100%"} px={8}>
        <Heading fontSize="22" mt={3} mb={2}>
          Registration starts in:
        </Heading>
        <DateCountdown
          dateString={tsOrStringToDate(dateString as string).toISOString()}
          message="Registration is open."
        />
        <Button
          float={"right"}
          variant="ghost"
          size="sm"
          onClick={() =>
            handleCalendar(
              projectData?.signupAccess?.startDate
                ? tsOrStringToDate(
                    projectData?.signupAccess?.startDate
                  ).toISOString()
                : undefined,
              projectData?.name + " is starting",
              projectData?.name +
                " is on, you can register now at " +
                window.location.href
            )
          }
        >
          remind me
        </Button>
      </Box>
    );
  }

  if (status === RegistrationStatus.willClose) {
    return (
      <Box w={"100%"} px={8}>
        <Heading fontSize="22" mt={3} mb={2}>
          Registration ends in:
        </Heading>
        <DateCountdown
          dateString={tsOrStringToDate(
            projectData?.signupAccess?.endDate as string
          ).toISOString()}
          message="Registration is closed."
        />
      </Box>
    );
  }

  return null;
}
